(() => {
  const privacyUrl = '/policies/privacy-policy#cookie-einstellungen';
  const cancellationUrl = 'https://account.polsterkonzept.com';

  const customerPrivacy = () => window.Shopify?.customerPrivacy;
  const consentAllowed = (kind) => {
    const privacy = customerPrivacy();
    const method = kind === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
    return typeof privacy?.[method] === 'function' && privacy[method]() === true;
  };

  const openPreferences = () => {
    const candidates = [window.privacyBanner, window.Shopify?.privacyBanner, customerPrivacy()];
    for (const candidate of candidates) {
      if (typeof candidate?.showPreferences === 'function') {
        candidate.showPreferences();
        return true;
      }
    }
    return false;
  };

  const announcePrivacyReady = () => document.dispatchEvent(new CustomEvent('pk:privacy-ready'));
  if (typeof customerPrivacy()?.analyticsProcessingAllowed === 'function') {
    announcePrivacyReady();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) announcePrivacyReady(); }
    );
  }

  const cookieLink = () => {
    const link = document.createElement('a');
    link.href = privacyUrl;
    link.textContent = 'Cookie-Einstellungen';
    link.dataset.pkCookiePreferences = '';
    return link;
  };

  const cancellationLink = () => {
    const link = document.createElement('a');
    link.href = cancellationUrl;
    link.textContent = 'Rückgabe & Stornierung';
    link.dataset.pkReturnCancellation = '';
    return link;
  };

  const addPolicyListLink = (policyList, link) => {
    const item = document.createElement('li');
    const text = document.createElement('small');
    text.className = 'copyright__content';
    text.appendChild(link);
    item.appendChild(text);
    policyList.appendChild(item);
  };

  const addFooterLegalLinks = () => {
    document.querySelectorAll('footer').forEach((footer) => {
      const policyList = footer.querySelector('ul.policies');
      if (policyList) {
        if (!footer.querySelector('[data-pk-cookie-preferences]')) addPolicyListLink(policyList, cookieLink());
        if (!footer.querySelector('[data-pk-return-cancellation]')) addPolicyListLink(policyList, cancellationLink());
        return;
      }

      const privacyLink = footer.querySelector('a[href*="/policies/privacy-policy"]');
      if (!privacyLink?.parentElement) return;
      if (!footer.querySelector('[data-pk-cookie-preferences]')) privacyLink.parentElement.appendChild(cookieLink());
      if (!footer.querySelector('[data-pk-return-cancellation]')) privacyLink.parentElement.appendChild(cancellationLink());
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pk-cookie-preferences]');
    if (!link) return;
    if (openPreferences()) event.preventDefault();
  });

  window.PKPrivacy = Object.freeze({
    analyticsAllowed: () => consentAllowed('analytics'),
    marketingAllowed: () => consentAllowed('marketing'),
    openPreferences,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addFooterLegalLinks, { once: true });
  } else {
    addFooterLegalLinks();
  }
})();
